import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

const Container = styled.div<SpaceProps>`
  background: ${(props) => props.theme.colors[props.color]};
  box-shadow: inset 1px 1px 5px rgba(0, 0, 0, 0.3);
  width: 60px;
  height: 28px;
  border-radius: 14px;
  position: relative;
  transition: all 0.3s ease;
  ${space}
`;

const Knob = styled.div<{ value: boolean }>`
  background-color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
  position: absolute;
  transform: translate3d(${(props) => (props.value ? 34 : 2)}px, 2px, 0);
  transition: all 0.3s ease;
`;

type ToggleProps = {
  value?: boolean;
  onChange?: (val: boolean) => void;
  noColor?: boolean;
} & SpaceProps;

const Toggle = ({ value, onChange, noColor, ...rest }: ToggleProps) => {
  return (
    <Container
      {...rest}
      color={noColor || !value ? "grey3" : "primary"}
      onClick={() => onChange(!value)}
    >
      <Knob value={value}></Knob>
    </Container>
  );
};

export default Toggle;
